import { GroupWeather } from '../GroupWeather';
import { PairRowView } from './PairRowView';
import { fmtDateLabel, type PairDateGroup } from './feedModel';
import type { IndiPhotoWork } from './useIndiPhotoWork';

/**
 * 공사현황 피드 본문 — 날짜 그룹(날짜·날씨 라벨 + '작업요청 N건 | 작업보고 N건') 아래 작업요청↔현장보고 페어 행.
 * 공사현황 전체 화면과 나의 현장 '공사현황' 탭 공용. 스크롤 컨테이너는 호출부가 소유한다(날짜 라벨이 그 안에서 sticky).
 */
export function WorklogFeedGroups({
  groups, work, readOnly, onOpenPhoto,
}: {
  groups: PairDateGroup[];
  work: IndiPhotoWork;
  /** 열람 전용(거래완료 현장) — 사진첩에 담기([사진선택]) 숨김 */
  readOnly?: boolean;
  onOpenPhoto: (frId: number, photoIdx: number) => void;
}) {
  const { workTarget } = work;
  return (
    <div className="space-y-04 pt-02">
      {groups.map((dg) => {
        // 선정 모드에선 대상 카드가 속한 날짜만 또렷하게 — 다른 날짜 라벨도 함께 흐린다.
        const groupHasTarget = dg.rows.some((row) =>
          row.frs.some((fr) => workTarget?.frId === fr.fr.fieldReportId),
        );
        const dimGroupLabel = workTarget != null && !groupHasTarget;
        return (
          <div key={dg.key}>
            {/*
              날짜 그룹 라벨 — 스크롤해도 목록 상단에 고정되고, 다음 날짜 헤더가 올라오면 이전 날짜를 밀어낸다(화면기획서 v1.8).
              그룹 래퍼 안에 두어 그룹이 끝나면 헤더도 함께 빠진다. 배경(bg-surface)이 비치지 않게 흐림(opacity)은
              고정 박스가 아니라 안쪽 줄에만 건다. z-10: z-sticky(1100)는 z-dropdown(1000)보다 높아 툴바 팝오버를 가려서 쓰지 않는다.
              고정 박스의 위·아래 패딩(py-03)이 카드와의 간격을 겸한다(카드가 헤더 밑으로 비쳐 보이지 않게).
            */}
            <div className="sticky top-0 z-10 bg-surface py-03">
              <div
                className={`flex items-center gap-2 transition-opacity duration-200 ${
                  dimGroupLabel ? 'opacity-40' : ''
                }`}
              >
                <span className="text-body-md font-bold text-text">{fmtDateLabel(dg.sample)}</span>
                {dg.weather && <GroupWeather weather={dg.weather} />}
                <span className="h-px flex-1 bg-border" />
              </div>
            </div>
            {/* 작업요청/작업보고 건수(실측 목업) */}
            <div className="mb-2 flex items-center text-caption font-semibold text-text-secondary">
              <span className="flex-1">작업요청 {dg.woCount}건</span>
              <span className="w-14 shrink-0" aria-hidden />
              <span className="flex-1">작업보고 {dg.frCount}건</span>
            </div>
            <div className="space-y-3">
              {dg.rows.map((row) => {
                const key = row.wo
                  ? `wo-${row.wo.wo.workOrderId}`
                  : `fr-${row.frs[0].fr.fieldReportId}`;
                return (
                  <PairRowView
                    key={key}
                    row={row}
                    readOnly={readOnly}
                    workTarget={workTarget}
                    savingFrId={work.savingFrId}
                    getDesignation={work.getDesignation}
                    onTogglePhoto={work.togglePhoto}
                    onEnterWork={work.enterWork}
                    onCancelWork={work.cancelWork}
                    onSaveWork={work.saveWork}
                    onOpenPhoto={onOpenPhoto}
                  />
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
